import React, { useRef, useEffect, useState } from "react";

import { Wait } from '../../components/wait';
import { CircularProgress } from "@mui/material"; 

export function LoadingWatermark({ text = 'Reconnecting...', displacement = 0 }) {
    const [timer, setTimer] = useState(0);
  
    const mounted = useRef(false);
    useEffect(() => {
      mounted.current = true;
  
      return () => (mounted.current = false);
    });
  
    useEffect(() => {
        async function increaseCounter(){
            await Wait(1000);
            if(mounted.current) setTimer(timer + 1);
            else return;
        }
    
        increaseCounter();
    });
  
    const bottomOffset = 24 + displacement;
    return (
        <div className="fixed flex right-6 z-50 items-center" style={{ bottom: `${bottomOffset}px` }}>
            <CircularProgress size={16}/>&nbsp;
            <div className="text-sm font-semibold" style={{ color: '#111827', fontWeight: '600', WebkitTextFillColor: '#111827' }}>{text}</div>
        </div>
    );
  }
  